// Import .less entry point
import '../assets/private/stylesheets/create-account/_create-account.less';
import './customer/styles/style';

import { init as initCompleteAccount} from './customer/complete-account/complete-account';

export const init = () => {
  const form = cube.$id('js-complete-account-form');
  if (form) initCompleteAccount(form);
};

document.addEventListener('DOMContentLoaded', init);



// WEBPACK FOOTER //
// ./src/complete-account.route.js